import React from 'react';
import '../styles/OAuthButtons.css';

const OAuthButtons = () => {
  const handleGoogleLogin = () => {
    window.location.href = `${process.env.REACT_APP_API_URL}/auth/google`;
  };

  const handleGitHubLogin = () => {
    window.location.href = `${process.env.REACT_APP_API_URL}/auth/github`;
  };

  return (
    <div className="oauth-buttons-container">
      <div className="oauth-divider">
        <span>или</span>
      </div>

      <div className="oauth-buttons">
        <button className="oauth-btn google" onClick={handleGoogleLogin}>
          <span className="oauth-icon">🔍</span>
          <span className="oauth-text">Continue with Google</span>
        </button>

        <button className="oauth-btn github" onClick={handleGitHubLogin}>
          <span className="oauth-icon">🐙</span>
          <span className="oauth-text">Continue with GitHub</span>
        </button>
      </div>
    </div>
  );
};

export default OAuthButtons;
